module.exports = __webpack_public_path__ + "img/Group 1-4.4f2c1d9e.svg";